var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useDataProvider, useEvent } from 'react-admin';
import { useMutation, useQueryClient, } from '@tanstack/react-query';
export var useAddRevision = function (resource, params, options) {
    if (options === void 0) { options = {}; }
    var dataProvider = useDataProvider();
    var queryClient = useQueryClient();
    var mutation = useMutation(__assign({ mutationFn: function (args) {
            var _a = args.resource, callTimeRessource = _a === void 0 ? resource : _a, _b = args.recordId, recordId = _b === void 0 ? params === null || params === void 0 ? void 0 : params.recordId : _b, _c = args.data, data = _c === void 0 ? params === null || params === void 0 ? void 0 : params.data : _c, _d = args.date, date = _d === void 0 ? params === null || params === void 0 ? void 0 : params.date : _d, _e = args.authorId, authorId = _e === void 0 ? params === null || params === void 0 ? void 0 : params.authorId : _e, _f = args.message, message = _f === void 0 ? params === null || params === void 0 ? void 0 : params.message : _f, _g = args.description, description = _g === void 0 ? params === null || params === void 0 ? void 0 : params.description : _g;
            return dataProvider.addRevision(callTimeRessource, {
                recordId: recordId,
                data: data,
                date: date,
                authorId: authorId,
                message: message,
                description: description,
            });
        }, onSuccess: function (_, params) {
            queryClient.invalidateQueries({
                queryKey: [
                    'getRevisions',
                    params === null || params === void 0 ? void 0 : params.resource,
                    { recordId: params === null || params === void 0 ? void 0 : params.recordId },
                ],
            });
        } }, options));
    var addRevision = function (resource_1, params_1) {
        var args_1 = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args_1[_i - 2] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([resource_1, params_1], args_1, true), void 0, function (resource, params, calltimeOptions) {
            var _a, returnPromise, otherOptions;
            if (calltimeOptions === void 0) { calltimeOptions = {}; }
            return __generator(this, function (_b) {
                _a = calltimeOptions.returnPromise, returnPromise = _a === void 0 ? options.returnPromise : _a, otherOptions = __rest(calltimeOptions, ["returnPromise"]);
                return [2 /*return*/, returnPromise
                        ? mutation.mutateAsync(__assign({ resource: resource }, params), otherOptions)
                        : mutation.mutate(__assign({ resource: resource }, params), otherOptions)];
            });
        });
    };
    return [useEvent(addRevision), mutation];
};
